import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {DownloadService} from '../../../Services/download.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {LanguageService} from '../../../../translation/Services/language.service';

@Component({
  selector: 'app-download-overview',
  templateUrl: './download-overview.component.html',
  styleUrls: ['./download-overview.component.scss']
})
export class DownloadOverviewComponent implements OnInit {

  public grid: Grid;
  public downloadId: number;
  public downloadCategoryName: string;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private router: Router,
    private downloadService: DownloadService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.download.category_name',
          prop: 'categoryName',
          sortable: true,
          type: TextColumn.type,
          width: 250,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.download.language_name',
          prop: 'language.name',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.download.store_user_access',
          prop: 'roles',
          sortable: false,
          type: TextColumn.type,
          width: 250,

          translate: true,
          valueFormatter: row => {
            const items = [];
            row.forEach(item => {
              items.push(this.translateService.instant(item.name));
            });
            return items.join(',');
          }
        },
        <TextColumn>{
          name: 'doctrine.download.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <NumberColumn>{
          name: 'doctrine.download.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          maxWidth: 100,
          minWidth: 100,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.downloadService.setPosition(position, row.id).subscribe((res) => {
              this.broadCastService.broadcast('refreshGrid', 'getDownloads');

            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/download/' + row.id),
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.downloadId = row.id;
                this.downloadCategoryName = row.categoryName.bold();
                this.deleteModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light ms-1'
            },
          ]
        },
      ],
      service: this.downloadService,
      rememberURL: this.router.url,
      method: 'getDownloads',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          name: 'language',
          type: 'ng-select',
          hasCalendar: false,
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          label: 'doctrine.download.language_name',
          hasStatus: false,
          value: new ServiceSearchItem(this.languageService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translateService.instant('global.all')});
            for (const row of res.languages) {
              options.push({value: row.name, label: row.name});
            }
            return options;
          })
        }
      ],

    };
  }

  delete() {
    this.downloadService.deleteDownload(this.downloadId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getDownloads');
    });
  }

}
